// import React, { useState } from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMHTMLEditor from "src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { StudentTestimonialFormValues } from "src/models/StudentTestimonial.model";
import ATMFilePickerWrapper from "src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";

type Props = {
  formikProps: FormikProps<StudentTestimonialFormValues>;
  onClose: () => void;
  editorValue?: string;
  formType: "Add" | "Edit";
  setSaveNextChecked?: any;
  saveNextChecked?: any;
};

const StudentTestimonialForm = ({
  formikProps,
  onClose,
  editorValue,
  formType,
  setSaveNextChecked,
  saveNextChecked,
}: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  return (
    <div className="flex flex-col flex-1 gap-4 p-4 overflow-hidden">
      <div className="flex items-center justify-between h-fit">
        <div className="text-xl font-medium">
          {formType === "Add" ? "Add Testimonial" : "Update Testimonial"}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="grid flex-1 grid-cols-2 gap-4 overflow-scroll">
        {/* Student name */}
        <ATMTextField
          required
          name="name"
          value={values?.name}
          onChange={(e) => setFieldValue("name", e.target.value)}
          label="Student Name"
          placeholder="Enter Student name"
          onBlur={handleBlur}
        />
        {/* currentCompany */}
        <ATMTextField
        required
          name="currentCompany"
          value={values?.currentCompany}
          onChange={(e) => setFieldValue("currentCompany", e.target.value)}
          label="Current Company"
          placeholder="Enter current company"
          onBlur={handleBlur}
        />
        {/* testimonial */}
        <div className="col-span-2">
          <ATMHTMLEditor
          required
            name="text"
            key={editorValue}
            label="Testimonial"
            value={values?.text}
            placeholder="Write here...."
            onChange={(newValue: any) => {
              setFieldValue("text", newValue);
            }}
          />
        </div>
        {/* userimage */}
        <ATMFilePickerWrapper
          name="image"
          label="Student Image"
          placeholder="select file"
          selectedFile={values?.image}
          onSelect={(imgUrl) => {
            setFieldValue("image", imgUrl);
          }}
        />
        <ATMTextField
          required
          name="video"
          value={values?.video}
          onChange={(e) => setFieldValue("video", e.target.value)}
          label="Student Video Review URl"
          placeholder="Enter URL"
          onBlur={handleBlur}
        />
      </div>

      <div className="h-fit">
        {formType === "Add" && (
          <div>
            <ATMCheckbox
              label="Save and Next"
              checked={saveNextChecked}
              onChange={(checked) => {
                setSaveNextChecked(checked);
              }}
            />
          </div>
        )}
        <div>
          <ATMLoadingButton isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default StudentTestimonialForm;
